import SettingHolidays from "./SettingHolidays"

function Setting() {
    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{paddingTop: "13px"}}>
                    <ul className="nav nav-tabs card-header-tabs">
                        <li className="nav-item">
                            <span className="nav-link active" aria-current="true">Sviatky</span>
                        </li>
                    </ul>
                </div>
                <div className="card-body">
                    <SettingHolidays />
                </div>
            </div>
        </div>
    )
}

export default Setting